const setSseEventSource = (state, sseEventSource) => {
    state.sseEventSource = sseEventSource;
};

const setSseResponseData = (state, sseResponseData) => {
    state.sseResponseData = sseResponseData;
};

const setIsSseEventSourceClosed = (state, isClosed) => {
    state.isSseEventSourceClosed = isClosed;
}

const setLastEventId = (state, lastEventId) => {
    state.lastEventId = lastEventId;
}

export default {
    setSseEventSource,
    setLastEventId,
    setSseResponseData,
    setIsSseEventSourceClosed
}



// WEBPACK FOOTER //
// ./src/store/modules/sse/mutations.js